import { Form } from '../../components/Shared/FormEngine/FormEngine.types';

const inventoryRequestWithShipping: Form = [
  {
    kind: 'field',
    name: 'topInfo',
    fieldLabel: '*Required fields',
    fieldType: 'text',
    required: true,
    optionsAutoSelected: false,
    permissionSets: [],
  },
  {
    kind: 'section',
    fields: [
      {
        kind: 'field',
        name: 'salesRep',
        isShow: true,
        fieldLabel: 'Sales Rep',
        fieldType: 'selectSingleDynamicAutoCompletePicker',
        required: true,
        optionsPlaceHolder: 'Sales Rep',
        optionsDynamic: 'getSalesReps',
        optionsAutoSelected: false,
        optionsDependentField: [],
        permissionSets: [],
      },
      {
        kind: 'field',
        name: 'primaryAccount',
        fieldLabel: 'Account',
        isShow: true,
        fieldType: 'selectSingleDynamicAutoCompletePicker',
        required: true,
        optionsPlaceHolder: 'Pick an Account',
        optionsDynamic: 'getAccounts',
        optionsAutoSelected: false,
        optionsDependentField: ['salesRep'],
        permissionSets: [],
      },
      {
        kind: 'field',
        name: 'shipTo',
        fieldLabel: 'Ship To',
        isShow: true,
        fieldType: 'selectSingleDynamicAutoCompletePicker',
        required: true,
        optionsPlaceHolder: 'Pick a Value',
        optionsDynamic: 'getShipToAddresses',
        optionsDependentField: ['primaryAccount'],
        optionsAutoSelected: false,
        permissionSets: [],
      },
      {
        kind: 'field',
        name: 'requestedReceivalDate',
        fieldLabel: 'Ship by Date',
        fieldType: 'dateTimePicker',
        required: true,
        isShow: true,
        optionsAutoSelected: false,
        date: true,
        time: false,
        permissionSets: [],
      },
      {
        kind: 'field',
        name: 'serviceLevel',
        fieldLabel: 'Service Level',
        fieldType: 'selectSingleDynamicAutoCompletePicker',
        required: true,
        isShow: true,
        optionsPlaceHolder: 'Service Level',
        optionsDynamic: 'getServiceLevel',
        optionsAutoSelected: false,
        optionsDependentField: [],
        permissionSets: [],
      },
      {
        kind: 'field',
        name: 'comments',
        fieldLabel: 'Comments',
        fieldType: 'comments',
        required: false,
        isShow: true,
        optionsAutoSelected: false,
        characterLimit: 32000,
        optionsPlaceHolder:
          'Do not use to enter patient information, complaints, or set extension request.',
        showOnWeb: true,
        permissionSets: [],
      },
      {
        kind: 'field',
        name: 'specificShipingDetails',
        fieldLabel: 'Specific Shipping Details',
        fieldType: 'radio',
        required: false,
        isShow: true,
        optionsPlaceHolder: 'Specific Shipping Details',
        optionsDynamic: '',
        optionsStatic: [
          { value: 'no', label: 'No', id: 'No' },
          { value: 'yes', label: 'Yes', id: 'Yes' },
        ],
        optionsDependentField: [],
        optionsAutoSelected: false,
        permissionSets: [],
      },
      {
        kind: 'field',
        name: 'liftGateNeeded',
        fieldLabel: 'Lift Gate Needed',
        fieldType: 'toggleSwitch',
        required: false,
        isShow: true,
        optionsAutoSelected: false,
        optionsPlaceHolder: '',
        optionsDynamic: '',
        optionsDependentField: [],
        permissionSets: [],
      },
      {
        kind: 'field',
        name: 'dockAvailable',
        fieldLabel: 'Dock Available',
        fieldType: 'toggleSwitch',
        required: false,
        optionsAutoSelected: false,
        isShow: true,
        optionsPlaceHolder: '',
        optionsDynamic: '',
        optionsDependentField: [],
        permissionSets: [],
      },
      {
        kind: 'field',
        name: 'shortTruckOnly',
        fieldLabel: 'Short Truck Only',
        fieldType: 'toggleSwitch',
        required: false,
        optionsAutoSelected: false,
        isShow: true,
        optionsPlaceHolder: '',
        optionsDynamic: '',
        optionsDependentField: [],
        permissionSets: [],
      },
      {
        kind: 'field',
        name: 'deliveryContractName',
        fieldLabel: 'Delivery Contact Name',
        isShow: true,
        fieldType: 'textBox',
        required: true,
        optionsPlaceHolder: 'Delivery Contact Name',
        optionsDynamic: '',
        optionsDependentField: [],
        optionsAutoSelected: false,
        permissionSets: [],
      },
      {
        kind: 'field',
        name: 'deliveryContractPhone',
        fieldLabel: 'Delivery Contact Phone',
        isShow: true,
        fieldType: 'textBox',
        required: true,
        optionsPlaceHolder: 'Delivery Contact Phone',
        optionsDynamic: '',
        optionsDependentField: [],
        optionsAutoSelected: false,
        permissionSets: [],
      },
      {
        kind: 'field',
        name: 'deliveryContractEmail',
        fieldLabel: 'Delivery Contact Email',
        fieldType: 'textBox',
        isShow: true,
        required: false,
        optionsPlaceHolder: 'Delivery Contact Email',
        optionsDynamic: '',
        optionsDependentField: [],
        optionsAutoSelected: false,
        permissionSets: [],
      },
      {
        kind: 'field',
        name: 'deliveryContractInstructions',
        fieldLabel: 'Delivery Instructions',
        isShow: true,
        fieldType: 'textArea',
        required: false,
        optionsPlaceHolder: "Delivery Instructions (e.g. Dock Hours, 48' or 53' Truck, etc.)",
        showOnWeb: true,
        optionsAutoSelected: false,
        permissionSets: [],
        showTooltip: true,
        characterLimit: 32000,
      },
    ],
  },
];

export default inventoryRequestWithShipping;
